import React, { useEffect, useState } from "react";
import CrudTable from "../components/CrudTable";
import { api } from "../lib/api";

const columns = [
  { key: "name", label: "Outlet" },
  { key: "code", label: "Code" },
  { key: "city", label: "City" },
  { key: "store_type", label: "Type" },
  { key: "power_requirement_kw", label: "Power (kW)" },
  { key: "installation_status", label: "Installation", status: true },
  { key: "status", label: "Status", status: true },
];

export default function Outlets() {
  const [brands, setBrands] = useState([]);
  useEffect(() => { api.get("/brands", { params: { limit: 200 } }).then((r) => setBrands(r.data.items)); }, []);
  const formFields = [
    { name: "brand_id", label: "Brand", type: "select", required: true, options: brands.map((b) => ({ value: b.id, label: b.name })) },
    { name: "name", label: "Outlet Name", required: true },
    { name: "code", label: "Outlet Code" },
    { name: "store_type", label: "Store Type", default: "QSR", type: "select",
      options: ["QSR", "Cloud Kitchen", "Retail", "Cafe", "Other"].map((s) => ({ value: s, label: s })) },
    { name: "power_requirement_kw", label: "Power (kW)", type: "number", default: 5.5 },
    { name: "expected_backup_hours", label: "Backup Hours", type: "number", default: 4 },
    { name: "contact_person", label: "Contact Person" },
    { name: "phone", label: "Phone" },
    { name: "email", label: "Email", type: "email" },
    { name: "city", label: "City", required: true },
    { name: "state", label: "State" },
    { name: "address", label: "Address", required: true, wide: true },
    { name: "pincode", label: "Pincode" },
    { name: "installation_status", label: "Installation Status", type: "select", default: "not_installed",
      options: [{ value: "not_installed", label: "Not installed" }, { value: "scheduled", label: "Scheduled" }, { value: "installed", label: "Installed" }] },
    { name: "status", label: "Status", type: "select", default: "pending",
      options: [{ value: "pending", label: "Pending" }, { value: "active", label: "Active" }, { value: "suspended", label: "Suspended" }] },
  ];
  return <CrudTable title="Outlets" description="Every location powered by RushGro FlexiPods." endpoint="/outlets" columns={columns} formFields={formFields} />;
}
